import type { Company } from "../lib/access";
import { MODULE_NAV } from "../lib/access";

const ROLE_LABEL: Record<Company["role"], string> = {
  super_admin: "Super admin",
  admin: "Admin",
  staff: "Staff",
};

export function Home({ company }: { company: Company }) {
  const active = MODULE_NAV.filter((m) => company.modules.includes(m.key));

  return (
    <>
      <header className="page-head">
        <h1>{company.name}</h1>
        <p className="muted">
          You are signed in as {ROLE_LABEL[company.role].toLowerCase()}.
        </p>
      </header>

      {active.length === 0 ? (
        <div className="card">
          <h2>No modules switched on yet</h2>
          <p className="muted">
            Your company has no products enabled. Hauzisha turns these on during onboarding.
          </p>
        </div>
      ) : (
        <div className="tiles">
          {active.map((m) => (
            <a className="tile" key={m.key} href={m.path}>
              <b>{m.label}</b>
              <span>Coming in a later phase</span>
            </a>
          ))}
        </div>
      )}
    </>
  );
}
